import { apiService } from 'core/services/apiService';

export const getUserTimeOffItemEndpoint = (id: number | string): string =>
	`user_time_offs/${id}`;

export const deleteUserTimeOff = async (id: number | string): Promise<void> => {
	await apiService.delete(getUserTimeOffItemEndpoint(id));
};
